import authRoutes from './auth'
import icsRoutes from './ics'
import rmsRoutes from './rms'
import esgRoutes from './esg'
import cybRoutes from './cyb'

const routes = [
	{
		path: '*',
		name: '404',
		component: () => import('@/apps/auth/Login.vue'),
		meta: {
			name: 'Page Not Found',
		},
	},

	{
		path: '/',
		name: 'home',
		component: () => import('@/apps/home/Home.vue'),
		props: { view: 'dashboard', scene: 'apps' },
		meta: {
			name: 'Home Dashboard',
			permissions: ['*'],
		},
	},

	{
		path: '/settings',
		name: 'settings',
		component: () => import('@/apps/home/Home.vue'),
		props: { view: 'settings', scene: 'dashboard' },
		meta: {
			name: 'Settings Dashboard',
			permissions: ['*'],
		},
	},

	{
		path: '/settings/users',
		name: 'settings-users',
		component: () => import('@/apps/home/Home.vue'),
		props: { view: 'settings', scene: 'users' },
		meta: {
			name: 'User Management',
			permissions: ['*'],
		},
	},

	{
		path: '/settings/entities',
		name: 'settings-entities',
		component: () => import('@/apps/home/Home.vue'),
		props: { view: 'settings', scene: 'entities' },
		meta: {
			name: 'Entity Management',
			permissions: ['*'],
		},
	},

	...authRoutes,
	...icsRoutes,
	...rmsRoutes,
	...esgRoutes,
	...cybRoutes,
]

export default routes
